import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, Grid, IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {computeSurfUtile, getAddresse, getDataInString} from "../RightAccordion";
import IconesRight from "../../pages/compos/IconesRight";
import InfoIcon from "@mui/icons-material/Info";
import IconMaison from "../../ico/IconMagasin";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import HeightIcon from "@mui/icons-material/Height";
import IconEtage2 from "../../ico/IconEtage2";
import IconMSquare2 from "../../ico/IconMSquare2";
import IconMur from "../../ico/IconMur";
import IconToit from "../../ico/IconToit";
import {resBdnb} from "../AttributBdnb";
import {getAddresse2, getAddresses} from "./HeaderDetails";
import {getNbEtage} from "../../svc/Utils";
import {formatTexte} from "../../pages/compos/KpiView";


export function checkSecondaire(l_usage_2) {
    if (l_usage_2) {

        let txt = l_usage_2.replaceAll('"', "").replaceAll('{', "").replaceAll('}', "");
        if (txt === "Annexe") {
            return ""
        }
        return txt;
    }
    return ""
}

function getUniqueBatiment(batiments,meta) {
    let res={}
    batiments.forEach(batiment => {
        if(!res[batiment.batiment_construction_id]){
            res[batiment.batiment_construction_id]={
                batiment_construction_id:batiment.batiment_construction_id,
                adresses:[],
                s_geom_cstr:batiment.s_geom_cstr,
                hauteur:batiment.hauteur,
                nb_etage:getNbEtage(batiment.hauteur, meta.annee_construction),
                surf_util:computeSurfUtile(batiment.hauteur, batiment.s_geom_cstr, meta.annee_construction)
            }
        }
            let a=getAddresse2(batiment)
            if(res[batiment.batiment_construction_id]['adresses'].indexOf(a)===-1){
                res[batiment.batiment_construction_id]['adresses'].push(a)
            }
    })

    return Object.values(res);
}

export default function BatimentsDetails({selectedItem}) {
    const [open, setOpen] = React.useState(true);

    return (<Box>


            <Box sx={{
                width: "95%",
                borderRadius: "8px",
                backgroundColor: "#f7f9fc",
                padding: 2,
                m: 1,
                marginBottom: 2,
            }}>
                <Box sx={{
                    display: "flex",
                    width: "100%",
                    borderColor: "#000",
                    borderBottomStyle: "solid",
                    height: 30
                }}>
                    <Typography>DESCRIPTION DES CONSTRUCTIONS</Typography>
                </Box>
                <Box sx={{width: "100%", display: "flex"}}>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "20%"
                    }}>
                        <Tooltip title="Nbre de Logements" sx={{mr: 1}}>
                            <span>
                            <IconMaison/>
                                </span>
                        </Tooltip>
                        {Math.ceil(selectedItem.metadonnees[0].nb_log)}
                    </Box>

                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "20%"
                    }}>
                        <Tooltip title="NBRE DE GARAGES/PARKINGS" sx={{mr: 1}}>
                            <LocalParkingIcon/>
                        </Tooltip>
                        {Math.ceil(selectedItem.metadonnees[0].nb_lot_garpark)}
                    </Box>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "30%"
                    }}>
                        <Tooltip title="MATERIAUX MUR" sx={{mr: 1}}>
                            <IconMur/>
                        </Tooltip>
                        {selectedItem.metadonnees[0].mat_mur_txt}
                    </Box>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "30%"
                    }}>
                        <Tooltip title="MATERIAUX TOIT" sx={{mr: 1}}>
                            <IconToit/>
                        </Tooltip>
                        {selectedItem.metadonnees[0].mat_toit_txt}
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: 250}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Usage Primaire : </Typography>

                    </Box>
                    <Box sx={{width: "50%"}}>

                        <Typography variant="body2"
                                    gutterBottom>{selectedItem.metadonnees[0].usage_niveau_1_txt}</Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: 250}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Usage Secondaire : </Typography>


                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{checkSecondaire(selectedItem.metadonnees[0].l_usage_2)}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: 250}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Surface Commerciale ou tertiaire : </Typography>

                    </Box>
                    <Box sx={{width: "50%"}}>

                        <Typography variant="body2"
                                    gutterBottom>{formatTexte(selectedItem.metadonnees[0]?.l_type_equipement)}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    borderColor: "#505050",
                    marginTop: 5
                }}>
                    <Grid container spacing={2}>
                        <Grid item xs={4.8}>

                        </Grid>
                        <Grid item xs={1.8} sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignContent: "center",
                            alignItems: "center"
                        }}>
                            <Tooltip title="superficie au sol occupée par le bâtiment" sx={{mr: 1}}>
                                <AspectRatioIcon/>
                            </Tooltip>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Emprise au sol</Typography>
                        </Grid>
                        <Grid item xs={1.8} sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignContent: "center",
                            alignItems: "center"
                        }}>
                            <Tooltip title="Hauteur du batiment ">

                                <HeightIcon/>
                            </Tooltip>

                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom> Hauteur</Typography>
                        </Grid>
                        <Grid item xs={1.8} sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignContent: "center",
                            alignItems: "center"
                        }}>
                            <Tooltip
                                title="Hauteur de l'immeuble / Hauteur sous plafond théorique (année construction)"
                                sx={{mr: 1}}>
                                        <span>
                                        <IconEtage2/>
                                        </span>
                            </Tooltip>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Nb. étage</Typography>
                        </Grid>
                        <Grid item xs={1.8} sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignContent: "center",
                            alignItems: "center"
                        }}>
                            <Tooltip title="Emprise au sol du batiment" sx={{mr: 1}}>
                                         <span>
                                            <IconMSquare2 title="Emprise au sol X nombre d'étage(s) calculé(s)"/>
                                     </span>
                            </Tooltip>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Surface utile</Typography>
                        </Grid>

                    </Grid>
                    {selectedItem.batiments.length > 0 &&
                        getUniqueBatiment(selectedItem.batiments,selectedItem.metadonnees[0]).map((l, index2) => {

                            return (
                                <Grid key={index2} container spacing={2} sx={{mb:1}}>
                                    <Grid item xs={4.8}>
                                        <Typography variant={"subtitle2"}>
                                            Bâtiment {index2 + 1}
                                        </Typography>
                                        {l.adresses.join(', ')}

                                    </Grid>
                                    <Grid item xs={1.8} sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography>{l.s_geom_cstr} m</Typography>
                                    </Grid>
                                    <Grid item xs={1.8} sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography>{l.hauteur} m</Typography>
                                    </Grid>
                                    <Grid item xs={1.8} sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography>{l.nb_etage}</Typography>
                                    </Grid>
                                    <Grid item xs={1.8} sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography>{l.surf_util} m²</Typography>
                                    </Grid>

                                </Grid>)
                        })}
                </Box>
            </Box>
            <Box sx={{
                width: "95%",
                borderRadius: "8px",
                backgroundColor: "#f7f9fc",
                padding: 2,
                m: 1,
                marginBottom: 2,
            }}>

                <Box sx={{
                    display: "flex",
                    width: "100%",
                    borderColor: "#000",
                    borderBottomStyle: "solid",
                    height: 30
                }}>
                    <Typography>RISQUE ENVIRONNEMENTAUX</Typography>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: 250}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Argile</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {selectedItem.metadonnees[0].argiles}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: 250}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Radon</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>

                            {selectedItem.metadonnees[0].radon}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

